const enum ECheckboxSize {
  small = 'small',
  medium = 'medium',
}

const enum ECheckboxType {
  withLabel = 'with-label',
  withoutLabel = 'without-label',
}

const ELabelTypographyVariant = {
  small: 'p12',
  medium: 'p16',
  large: 'p16',
} as const;

export { ECheckboxSize, ECheckboxType, ELabelTypographyVariant };
